"use client"

import { useEffect } from 'react';
import { useLogger } from '@logtail/next';
import { PageErrorMessage } from '~/components/utility/error/page';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const log = useLogger();

  useEffect(() => {
    log.error('Client error boundary caught error', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: window.location.href,
    });

    const key = 'error-reload:' + window.location.pathname;
    const last = sessionStorage.getItem(key);
    if (!last || Date.now() - Number(last) > 10000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }, [error]);

  return <PageErrorMessage />;
}
